import { render } from "./SimplePagination.vue?vue&type=template&id=1c141a4a"
import script from "./SimplePagination.vue?vue&type=script&lang=js"
export * from "./SimplePagination.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Host\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__